import React, {useContext, useEffect, useState} from "react";
import {
    Datagrid,
    TextField,
    TopToolbar,
    sanitizeListRestProps,
    useRecordContext,
    Button,
    usePermissions, useAuthenticated, ShowButton, FunctionField,
} from "react-admin";
import ListMod from "Component/Redesign/ListMod";
import CreateButtonMod from "Component/Layouts/Button/CreateButton";
import CrudMod from "Component/Layouts/Button/CrudMod";
import { LabelValueFromConst } from "Component/Handlers/ValueFromConst";
import { Role } from "../Constant/Role";
import { Status } from "../Constant/Status";
import LockRounded from '@mui/icons-material/LockRounded'
import Tooltip from '@mui/material/Tooltip'
import StatusField from "Component/Layouts/Field/StatusField";
import { Boolean } from "../Constant/Boolean";
import OnDutyField from "Component/Layouts/Field/OnDutyField";
import { DateFieldMod } from "../../../Component/Layouts/Field";
import { ListFilter } from "../Filter/ListFilter";
import { useTranslate } from "react-admin";
import { NoResults } from "Component/NoResults/NoResults";
import PhotoButton from "Component/Layouts/Button/PhotoButton";
import {useUser} from "../../../context/userProvider";

const ListActions = ({ basePath, className, ...rest }) => {
  const { permissions } = usePermissions();

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {permissions !== "ROLE_DOCTOR" && (
        <CreateButtonMod basePath={basePath} label="ra.action.create" />
      )}
    </TopToolbar>
  );
};

const ChangePassword = () => {
  const { id } = useRecordContext();
  const translate = useTranslate();

  return (
    <Button href={`#/admins/password/${id}`}>
      <Tooltip title={translate("buttons.changePassword")}>
        <LockRounded />
      </Tooltip>
    </Button>
  );
};

const RoleField = (props) => {
  const record = useRecordContext();
  if (record[props.source] !== undefined) {
    return LabelValueFromConst(
      Role,
      record[props.source].replace(/[^A-Z^-a-z]/g, "", "")
    );
  }

  return LabelValueFromConst(Role, record[props.source]);
};

export const AdminsList = ({ permissions, ...props }) => {
  useAuthenticated();

  const { user } = useUser();
  const { permissions: rightPermissions } = usePermissions();
  const translate = useTranslate();
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    setUserId(user && rightPermissions === "ROLE_DOCTOR" ? { id: [user.id] } : null)
  }, [user, rightPermissions]);

  return rightPermissions !== 'ROLE_ADMIN' && !userId ? null : (
    <ListMod
      {...props}
      actions={<ListActions />}
      title="Admin management"
      basePath="/admins"
      filters={<ListFilter />}
      filter={
        userId || ''
      }
    >
      <Datagrid bulkActionButtons={false} rowClick={false} empty={<NoResults />}>
        <TextField source="firstName" />
        <TextField source="lastName" />
        <TextField source="email" />
        <RoleField source="role" sortable={false} />
        <StatusField source="status" statusList={Status} sortable={true} />
        <OnDutyField source="isOnDuty" list={Boolean} sortable={true} />
        <TextField source="description" sortable={false} />
        <DateFieldMod
          source="createdAt"
          options={{ day: "2-digit", month: "2-digit", year: "numeric" }}
        />
        <PhotoButton />
        <CrudMod edit="true" del="true">
          <ChangePassword />
          <FunctionField
              source="doctor"
              render={(record) =>
                  record.id ?
                      <Tooltip title={translate("ra.action.show")}>
                          <ShowButton t {...props} label="" to={{pathname: '/admins/' + record.id + '/show' + (record.role !== 'ROLE_ADMIN' ? '/clients' : '')}} />
                      </Tooltip>
                      : ""
              }
              sortable={false}
          />
        </CrudMod>
      </Datagrid>
    </ListMod>
  );
};
